export const SOURCE_TYPE_LABELS: Record<string, string> = {
  paycode: 'Paycode',
  work_rule: 'Work rule',
  availability: 'Availability',
};

export const SOURCE_TYPE_FILTERS = Object.entries(SOURCE_TYPE_LABELS).map(
  ([value, text]) => ({ text, value })
);

export function sourceTypeLabel(sourceType: string): string {
  return SOURCE_TYPE_LABELS[sourceType] ?? sourceType;
}
